import React, { useRef, useEffect, useState } from "react";

export function Hero({ onContactClick }) {
  const videoRef = useRef(null);
  const [videoDuration, setVideoDuration] = useState(0);
  const [windowHeight, setWindowHeight] = useState(0);

  useEffect(() => {
    const video = videoRef.current;
    const handleVideoLoad = () => {
      if (video) {
        setVideoDuration(video.duration);
        setWindowHeight(window.innerHeight);
      }
    };

    const handleScroll = () => {
      if (!video || !videoDuration) return;

      const scrollPosition = window.scrollY;
      const scrollZone = windowHeight * 0.3;
      const scrollPercentage = Math.min(
        Math.max(scrollPosition / scrollZone, 0),
        1
      );

      video.currentTime = scrollPercentage * videoDuration;
    };

    if (video) {
      video.addEventListener("loadedmetadata", handleVideoLoad);
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      if (video) {
        video.removeEventListener("loadedmetadata", handleVideoLoad);
      }
      window.removeEventListener("scroll", handleScroll);
    };
  }, [videoDuration, windowHeight]);

  return (
    <section
      id="accueil"
      className="relative min-h-screen flex items-center justify-center"
    >
      <div className="absolute inset-0">
        <video
          ref={videoRef}
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source
            src="/assets/videos/main-mobile.mp4"
            type="video/mp4"
            media="(max-width: 768px)"
          />
          <source src="/assets/videos/main.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-black bg-opacity-5"></div>
      </div>

      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8">
        <div className="w-[200px] sm:w-[300px] h-[200px] sm:h-[300px] mx-auto mb-8 sm:mb-12 flex items-center justify-center">
          <img
            src="/assets/icons/logo-blanc.svg"
            alt="PLR Park Logo"
            className="w-full h-full object-contain"
          />
        </div>
        <p className="text-lg sm:text-xl md:text-3xl text-white mb-8 sm:mb-12">
          Louez votre place de parking sécurisée et profitez d'un service de
          navette direct vers l'aéroport de Beauvais-Tillé.
        </p>
        <button
          onClick={onContactClick}
          className="bg-[#FF7954] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold 
                   uppercase tracking-wide transform hover:scale-105 transition-all
                   hover:bg-[#e66a45] hover:shadow-lg w-full sm:w-auto"
        >
          Nous contacter
        </button>
      </div>
    </section>
  );
}
